import { KibButtonNew } from '@chewy/kib-controls-react';
import React from 'react';
import { ANALYTICS_ACTION_CLICK } from '../../AnalyticsProvider';
import { Branding } from '../../types/puppyGuide';
import { imgPath } from './constants';
import './promo.scss';

const Promo = ({
  branding: { title, logo, content, link, img, buttonText, className, analyticsLabel },
  recordAnalytics,
}: {
  branding: Branding;
  recordAnalytics: (analyticsEvent: string, analyticsLabel: string) => void;
}) => (
  <div className="starter-guide-container">
    <h3 className="starter-guide-section-header">{title}</h3>
    <div className={`chewy-pet-promo ${className}`}>
      <div className="chewy-pet-promo__image-container">
        <img src={`${imgPath}${img.src}`} alt={img.alt} className="chewy-pet-promo__image" />
      </div>
      <div className="chewy-pet-promo__main">
        <picture>
          <source media="(max-width: 640px)" srcSet={`${imgPath}${logo.mobile.src}`} />
          <img src={`${imgPath}${logo.desktop.src}`} alt={logo.desktop.alt} />
        </picture>
        <div className="chewy-pet-promo__content">{content}</div>
        <KibButtonNew
          data-testid={`${className}-testid`}
          className="chewy-pet-promo__label"
          onClick={() => {
            recordAnalytics(ANALYTICS_ACTION_CLICK, analyticsLabel);
          }}
          role="link"
          href={link}
          emphasis="secondary"
        >
          {buttonText}
        </KibButtonNew>
      </div>
    </div>
  </div>
);

export default Promo;
